// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import { API } from "aws-amplify";
import ReactAudioPlayer from 'react-audio-player';

function Fetch() {
  const params = useParams();
  const [ url, seturl ] = useState("");

  API.get('qsembed','/fetchaudio/' + params.Id, null).then((response) => {
    seturl(response.presignedUrl);
  }).catch((error) => {
    console.log(error);
  });

  return (
    <>
      <h2>Recording for Contact ID {params.Id}</h2>
      <ReactAudioPlayer
      src={url}
      controls
      />
    </>
  )
}

export default Fetch;

